module.exports = __webpack_public_path__ + "static/media/56687B.8c736bb9.jpg";